import { Tooltip_detail as Tooltip } from "../../utility/common/helpers/Tooltip";
import Img from "../../../icons/ErrorIcon.svg";
import {
  TripleInput,
  Process_Grid_Input,
  Process_Grid_Input_2
} from "../../utility/common/TransactionComponents/Common_WPS_WPQ_PQR_Process_Input_Fields";

export const PQRProcessGridInput3 = ({
  status,
  message,
  wps_detail,
  ColumnHeader,
  Columndimension,
  type,
  name,
  handleChange,
  maxLength,
  onInput,
  width,
  singleInputMode = false // New prop to control single vs triple input
}) => {
  return (
    <tr className={status ? "border WpsInput-md error" : "border WpsInput-md"}>
      <th className="text-start thead-color">
        <div>
          {ColumnHeader}
          <span>{Columndimension}</span>
          {status && (
            <Tooltip content={message}>
              <img src={Img} alt="Error" className="ms-1" />
            </Tooltip>
          )}
        </div>
      </th>
      {wps_detail && wps_detail.map((item, id) => {
        const disabled = wps_detail[id]?.PQR_Process === "";

        return (
          <td
            className={message ? "border WPSSelect error" : "border WPSSelect"}
            key={item?.PK || item?.SK || `${name}-${id}`}
          >
            <TripleInput
              item={item}
              name={name}
              type={type}
              maxLength={maxLength}
              disabled={disabled}
              status={status}
              onChange={handleChange}
              id={id}
              onInput={onInput}
              singleInputMode={singleInputMode}
              width={width}
            />
          </td>
        );
      })}
    </tr>
  );
};

export const PQRProcessGridInput2 = ({
  status,
  item,
  message,
  wps_detail,
  ColumnHeader,
  Columndimension,
  ColumnHeader2Dimension,
  type,
  name,
  setError,
  error,
  value,
  readOnly,
  mainheading,
  onInput1,
  handleChangedetailsarray,
  maxLength1,
  maxLength2,
  width1,
  onInput,
  ColumnHeader1,
  name1,
  onBlur,
  onBlur1,
  thstyle2
}) => {
  return (
    <Process_Grid_Input_2
      status={status}
      message={message}
      ColumnHeader={ColumnHeader}
      Columndimension={Columndimension}
      ColumnHeader2Dimension={ColumnHeader2Dimension}
      type={type}
      name={name}
      readOnly={readOnly}
      mainheading={mainheading}
      handleChangedetailsarray={handleChangedetailsarray}
      ColumnHeader1={ColumnHeader1}
      name1={name1}
      wps_detail={wps_detail}
      maxLength1={maxLength1}
      maxLength2={maxLength2}
      width1={width1}
      thstyle2={thstyle2}
      onInput={onInput}
      onInput1={onInput1}
      onBlur={onBlur}
      onBlur1={onBlur1}
    />
  );
};

export const PQR_Process_Grid_Select = ({
  status,
  message,
  wps_detail,
  ColumnHeader,
  Columndimension,
  name,
  readOnly,
  array,
  handleChangedetailsarray,
}) => {
  return (
    <tr className={status ? "border WpsInput-md error" : "border WpsInput-md"}>
      <th
        className={"text-start thead-color"}
      >
        <div>
          {ColumnHeader}
          <span>{Columndimension}</span>

          {status && (
            <Tooltip content={message}>
              <img src={Img} alt="Error" className="ms-1" />
            </Tooltip>
          )}
        </div>
      </th>
      {wps_detail.map((item, id) => {

        let disabled = wps_detail[id]?.PQR_Process === ""
        return (

          <td
            className={status ? "border WPSSelect error" : "border WPSSelect"}
            key={item?.PK || item?.SK || `${name}-${id}`}
          >
            <select
              style={{
                width: "272px",
                height: "38px",
                // borderColor: "#D8D8D8",
                borderRadius: "3px",
              }}
              className={status ? "error-input" : ""}
              readOnly={readOnly}
              disabled={disabled}
              name={name}
              value={item[name]}
              onChange={(e) => {
                handleChangedetailsarray(e, id);
              }}
            >
              <option value=""></option>
              {array &&
                array.map((e, id) => {
                  return (
                    <option key={e.value || `option-${id}`} value={e.value}>
                      {e.name}
                    </option>
                  );
                })}

            </select>
          </td>
        );
      })}
    </tr>
  );
};

export const PQRFillerMetalInput = ({
  status,
  message,
  wps_detail,
  ColumnHeader,
  Columndimension,
  type,
  name,
  width,
  setError,
  handleChangedetailsarray,
  maxLength,
  handleOnInput,
  TypeofCheck,
}) => {
  return (
    <Process_Grid_Input
      status={status}
      message={message}
      ColumnHeader={ColumnHeader}
      Columndimension={Columndimension}
      type={type}
      name={name}
      width={width}
      setError={setError}
      handleChangedetailsarray={handleChangedetailsarray}
      maxLength={maxLength}
      wps_detail={wps_detail}
      handleOnInput={handleOnInput}
      TypeofCheck={TypeofCheck}
      isFillerMetal={true}
    />
  );
};

/* export const PQRFillerMetalSelect = ({
  status,
  message,
  wps_detail,
  ColumnHeader,
  Columndimension,
  name,
  setError,
  setdetailObj,
  ActiveData,
  detailObj,
  width,
}) => {
  return (
    <tr className={status ? "border PQRInput-md error" : "border PQRInput-md"}>
      <th
        className="text-start thead-color"
      >
        <div>
          <div className="fillermetalheader">{ColumnHeader} </div>

          <span>{Columndimension}</span>
          {status && (
            <Tooltip content={message}>
              <img src={Img} alt="Error" className="ms-1" />
            </Tooltip>
          )}
        </div>
      </th>

      {wps_detail.map((item, id) => {
        let disabled = wps_detail[id]?.PQR_Process === ""
        let val = item[name] == undefined ? "" : item[name]
        return (
          <td
            className={message ? "border PQRSelectProcess error" : "border PQRSelectProcess"}
            key={id}
          >
            <SearchSelect
              required
              data={ActiveData}
              // stylegreen={error.PQR_BM_BM_Pno.status ? errorstyle : blyestyle}
              disabled={disabled}
              valueField={"wld_code"}
              value={val}
              labelField={"wld_code"}
              placeholder=""
              className={status ? "error-input" : ""}
              customstyles={{
                container: (provided) => ({
                  ...provided,
                  width: width ? `${width}px` : "auto",
                  display: "inline-block",
                  margin: "5px"
                })
              }}

              onChange={(e) => {
                item[name] = e.value;
                setdetailObj([...detailObj]);
                setError((prevState) => ({
                  ...prevState,
                  [name]: { status: false, message: "" },
                }));
                item.name !== ""
                  ? (detailObj[id].error = false)
                  : (detailObj[id].error = true)

              }}
            ></SearchSelect>
          </td>
        );
      })}
    </tr>
  );
};
 */